import React from 'react';
import { proofMetrics } from '../data/offer';
export function ProofBar() {
  return <section aria-label="Ce que contient le système" className="w-full bg-graphite text-creme" data-id="element-221" data-mp="m9p2ievgpne6">
      <div className="mx-auto w-full max-w-6xl px-6 py-10 md:px-10" data-id="element-222" data-mp="7lu9exdjlh0k">
        <dl className="grid grid-cols-1 divide-y divide-warm-lineDark sm:grid-cols-2 sm:divide-y-0 lg:grid-cols-4 lg:divide-x" data-id="element-223" data-mp="ck5kfbfkpxkd">
          {proofMetrics.map(metric => <div key={metric.label} className="flex flex-col gap-1 py-5 lg:px-6 lg:py-2 lg:first:pl-0 lg:last:pr-0" data-id="element-224" data-mp="3uogwnt3bupy7">
              <dt className="font-serif text-xl font-semibold leading-tight text-creme md:text-2xl" data-id="element-225" data-mp="3ksdxmw3rv7fh">
                {metric.figure}
              </dt>
              <dd className="text-xs leading-relaxed text-creme/60" data-id="element-226" data-mp="3psrvjlbnt0zs">
                {metric.label}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}